import { create } from 'zustand';
import { persist } from 'zustand/middleware';


interface UserChoicesState {
    choices: any[];
    currentStepIndex: number;
    addChoice: (choice: Omit<any, 'timestamp'>) => void;
    updateCurrentStep: (stepIndex: number) => void;
    clearChoices: () => void;
    getChoiceByStepId: (stepId: string) => any | undefined;
}

export const useUserChoicesStore = create<UserChoicesState>()(
    persist(
        (set, get) => ({
            choices: [],
            currentStepIndex: 1,

            addChoice: (choice) => set((state) => {
            const already = state.choices.find((item:any) =>
                item.stepTitle === choice.content.stepTitle
            )
                if(already) {
                    return state;
                }
                // Add new choice with timestamp
                return {
                    ...state,
                    choices: [
                        ...state.choices,
                        {
                            ...choice.content
                        }
                    ],
                };
            }),

            updateCurrentStep: (stepIndex) => {
                const state = get();
                // Only update if the step index is valid (1 or greater)
                if (stepIndex >= 1) {
                    // If going back, remove choices for steps after the current step
                    if (stepIndex < state.currentStepIndex) {
                        set((state) => ({
                            choices: state.choices.filter((choice) => {
                                const choiceStep = parseInt(choice.stepId);
                                return !isNaN(choiceStep) && choiceStep <= stepIndex;
                            }),
                            currentStepIndex: stepIndex
                        }));
                    } else {
                        set({ currentStepIndex: stepIndex });
                    }
                }
            },

            clearChoices: () => set({
                choices: [],
                currentStepIndex: 1
            }),

            getChoiceByStepId: (stepId) => {
                const state = get();
                return state.choices.find((choice) => choice.stepId === stepId);
            },
        }),
        {
            name: 'user-choices-storage',
            version: 1,
            // Only persist choices, not the current step
            partialize: (state) => ({
                choices: state.choices
            }),
        }
    )
);
